module.exports = __webpack_public_path__ + "img/bag.8c9804c0.svg";